import { DateRangeBox } from 'devextreme-react';
import DataGrid, {
    Column,
    FilterRow,
    Paging,
    Selection,
} from 'devextreme-react/data-grid';
import { Popup } from 'devextreme-react/popup';
import moment from 'moment';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Card, CardBody, Col, Input, Row } from 'reactstrap';
import Breadcrumb from '../../components/common/breadcrumb';
import api from '../../services/api-configuration';

const DisDepoGrupajIptal = () => {
    const [dataSource, setDataSource] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [selectedVehicles, setSelectedVehicles] = useState([]);
    const [selectedGroupageNo, setSelectedGroupageNo] = useState(null);

    const getAllGrupaj = async () => {
        try {
            const response = await api.post("/getAllGroupages", {
                "approved_end": document.getElementById("grupajOnayTarih").childNodes[2].childNodes[0].childNodes[0].value === "" ? null : moment(document.getElementById("grupajOnayTarih").childNodes[2].childNodes[0].childNodes[0].value).format("YYYY-MM-DD 23:59:59"),
                "approved_start": document.getElementById("grupajOnayTarih").childNodes[0].childNodes[0].childNodes[0].value === "" ? null : moment(document.getElementById("grupajOnayTarih").childNodes[0].childNodes[0].childNodes[0].value).format("YYYY-MM-DD 00:00:00"),
                "chassis_no": document.getElementById("sase").value === "" ? null : document.getElementById("sase").value,
                "shipping_type_ids": [5],
            });

            const filteredData = response.data.data?.filter(item => item.status !== "CANCELED") || [];
            setDataSource(filteredData);
        } catch (error) {
            toast.error("Veri getirme işlemi başarısız oldu");
            console.error("Error fetching groupages:", error);
        }
    };

    const handleRevertProcess = async () => {
        document.getElementById('revertProcess').disabled = true;
        document.getElementById('cancel-button').disabled = true;
        try {
            await api.post("/revertProcess", {
                groupage_no: selectedGroupageNo
            });
            toast.success("Grupaj başarıyla iptal edildi");

            setTimeout(() => {
                setShowConfirmPopup(false);
                getAllGrupaj();
            }, 1000);

        } catch (error) {
            toast.error("Grupaj iptal edilemedi");
            console.error('Error cancelling groupage:', error);
        } finally {
            document.getElementById('revertProcess').disabled = false;
            document.getElementById('cancel-button').disabled = false;
        }
    };

    const showVehicleDetails = (rowData) => {
        setSelectedVehicles(rowData.vehicles || []);
        setShowPopup(true);
    };

    const showCancelConfirmation = (data) => {
        setSelectedVehicles(data.vehicles || []);
        setSelectedGroupageNo(data.groupage_no);
        setShowConfirmPopup(true);
    };

    const ActionButtons = ({ data }) => (
        <div className="d-flex justify-content-center align-items-center gap-2">
            <i
                style={{

                    cursor: "pointer",
                    color: "red",
                    textDecoration: "underline"

                }}
                onClick={() => showCancelConfirmation(data)}
                disabled={data.status === "CANCELED"}

                title={data.status === "CANCELED" ? "Bu grupaj zaten iptal edilmiş" : "Grupajı iptal et"}
            >
                İptal Et
            </i>
        </div>
    );

    const ActionButtons2 = ({ data }) => (
        <div className="d-flex justify-content-center align-items-center gap-2">
            <i
                style={{

                    cursor: "pointer",
                    color: "blue",
                    textDecoration: "underline"
                }}
                onClick={() => showVehicleDetails(data)}
                title="Araç detaylarını görüntüle"
            >
                Görüntüle
            </i>
        </div>
    );

    return (
        <>
            <Breadcrumb current="Dış Depo Grupaj İptal" />
            <div className="p-2">
                <Card className="mb-4">
                    <CardBody>
                        <Row className="mb-3"
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "end"
                            }}
                        >
                            <Col md="4">
                                <Row className="mb-2">
                                    <label className="col-md-4 col-form-label"><b>Şase</b></label>
                                    <div className="col-md-8">
                                        <Input
                                            id="sase"
                                            placeholder="Şase numarası giriniz"
                                        />
                                    </div>
                                </Row>
                            </Col>
                            <Col md="4">
                                <Row className="mb-2">
                                    <label className="col-md-4 col-form-label"><b>Grupaj Onay Tarih</b></label>
                                    <div className="col-md-8">
                                        <DateRangeBox
                                            id="grupajOnayTarih"
                                            showClearButton={true}
                                            openOnFieldClick={false}
                                        />
                                    </div>
                                </Row>
                            </Col>
                            <Col md="2"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >
                                <button
                                    onClick={getAllGrupaj}
                                    className="btn btn-success"
                                >
                                    <i className="fa fa-list"></i>
                                    &nbsp;
                                    Listele
                                </button>
                            </Col>
                        </Row>

                    </CardBody>
                </Card>

                <DataGrid
                    dataSource={dataSource}
                    showBorders={true}
                    showRowLines={true}
                    showColumnLines={true}
                    hoverStateEnabled={true}
                    height="calc(100vh - 350px)"
                >
                    <FilterRow visible={true} />
                    <Selection mode="none" />
                    <Paging defaultPageSize={20} />

                    <Column dataField="groupage_no" caption="Grupaj No" minWidth={150} />
                    <Column dataField="from_warehouse_name" caption="Nereden" minWidth={180} />
                    <Column dataField="to_warehouse_name" caption="Nereye"
                        minWidth={200}
                    />
                    <Column
                        dataField="approved_date"
                        caption="Grupaj Onay Tarih"
                        dataType="datetime"
                        minWidth={200}
                        calculateDisplayValue={(row) =>
                            row.approved_date ?
                                moment(row.approved_date).format("DD/MM/YYYY HH:mm") :
                                moment(row.create_date).format("DD/MM/YYYY HH:mm")
                        }
                    />
                    <Column
                        dataField="vehicle_count"
                        caption="Adet"
                        alignment="center"
                        minWidth={150}
                    />
                    <Column caption="Şase Listesi" cellRender={(cellData) => <ActionButtons2 data={cellData.data} />} width={100} alignment="center" />
                    <Column
                        caption="İşlemler"
                        cellRender={(cellData) => <ActionButtons data={cellData.data} />}
                        width={150}
                        alignment="center"
                    />
                </DataGrid>

                {/* Details Popup */}
                <Popup
                    visible={showPopup}
                    onHiding={() => setShowPopup(false)}
                    dragEnabled={false}
                    closeOnOutsideClick={true}
                    showTitle={true}
                    title="Araç Detayları"
                    width={800}
                    height={400}
                >
                    <DataGrid
                        dataSource={selectedVehicles}
                        showBorders={true}
                        showRowLines={true}
                        showColumnLines={true}
                    >
                        <Column dataField="chassis_no" caption="Şase No" />
                        <Column dataField="brand" caption="Marka" />
                        <Column dataField="model" caption="Model" />
                        <Column dataField="color" caption="Renk" />
                    </DataGrid>
                </Popup>

                {/* Confirmation Popup */}
                <Popup
                    visible={showConfirmPopup}
                    onHiding={() => setShowConfirmPopup(false)}
                    dragEnabled={false}
                    closeOnOutsideClick={true}
                    showTitle={true}
                    title="İptal Onayı"
                    width={800}
                    height={550}
                >
                    <div className="p-4">
                        <div className="alert alert-danger mb-4">
                            <strong>Dikkat!</strong> Aşağıdaki araçların grupajı iptal edilecektir. Onaylıyor musunuz?
                        </div>

                        <DataGrid
                            dataSource={selectedVehicles}
                            showBorders={true}
                            showRowLines={true}
                            showColumnLines={true}
                            height={250}

                        >
                            <Column dataField="chassis_no" caption="Şase No" />
                            <Column dataField="brand" caption="Marka" />
                            <Column dataField="model" caption="Model" />
                            <Column dataField="color" caption="Renk" />
                        </DataGrid>

                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <button
                                id='cancel-button'
                                className="btn btn-secondary mr-2"
                                onClick={() => setShowConfirmPopup(false)}
                            >
                                <i className="fa fa-times me-2"></i> &nbsp;
                                Vazgeç
                            </button>
                            <button
                                id='revertProcess'
                                className="btn btn-danger"
                                onClick={handleRevertProcess}
                            >
                                <i className="fa fa-check me-2"></i> &nbsp;
                                İptal Et
                            </button>
                        </div>
                    </div>
                </Popup>
            </div>
        </>
    );
};

export default DisDepoGrupajIptal;